import { RootState } from '../reducers'
import { initialAuthenticationState } from './reducer'

export const credentialsSelector = (state: RootState) => state.authentication.credentials
export const apiTokenSelector = (state: RootState) => state.authentication.apiToken
export const set2fa = (state: RootState) => state?.authentication?.set2fa || initialAuthenticationState.set2fa
export const isConnectedSelector = (state: RootState) => state?.authentication?.isConnected || initialAuthenticationState.isConnected
